import React from 'react';
import Select from 'react-select';
import styles from './styles/index.module.scss';
import { stylesStatusTaskSelect } from '../../../Applications/consts';

const CheckboxOption = (props: any) => {
  const { innerProps, isSelected, data, selectOption } = props;

  return (
    <div {...innerProps} className={styles['option']}>
      <input
        type="checkbox"
        checked={isSelected}
        readOnly
        onClick={e => {
            e.stopPropagation()
            selectOption(data)
        }}
      />
      <label>{data.label}</label>
    </div>
  );
};

const MultiSelectWithCheckboxes = ({ options, value, onChange }: any) => {
  return (
    <Select
      options={options}
      value={value}
      onChange={onChange}
      components={{ Option: CheckboxOption }}
      isMulti
      hideSelectedOptions={false}
      className={styles['rrr']}
      styles={stylesStatusTaskSelect}
      placeholder='Выберите статус'
    />
  );
};

export default MultiSelectWithCheckboxes;